import React from 'react';
import Button from '@mui/material/Button';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

interface Props {
    onClick(e: React.MouseEvent<HTMLElement>):void,
    label:string,
    id:string,
    disabled?:boolean;
    type?:string;
}

const NavButton = (props:Props)=> {
    let disabled = false;
    if( props.disabled ){
        disabled = true;
    }
    if( props.type && props.type==="bottom" ){
        return (
            <Button variant="text" color="primary" onClick={props.onClick} data-id={props.id} style={{marginBottom:"0.5em"}} disabled={disabled}><ArrowForwardIcon/>{props.label}</Button>
        )
    } else {
        return (
            <Button variant="outlined" color="primary" onClick={props.onClick} data-id={props.id} style={{marginBottom:"0.5em"}} disabled={disabled}>{props.label}</Button>
        )
    }
}

export default NavButton;